document.addEventListener('DOMContentLoaded', function () {
  const phoneNumberInputs = document.querySelectorAll('[data-phoneNumber], [data-orderNumber]');
  phoneNumberInputs.forEach(function (input) {
    input.addEventListener('keypress', function (e) {
      const charCode = e.which ? e.which : e.keyCode;
      if (String.fromCharCode(charCode).match(/[^0-9]/g)) {
        e.preventDefault();
      }
    });
  });

  let alertShown = false;
  document.getElementById('contact_form').addEventListener('submit', function (event) {
    let inputs = document.querySelectorAll('[data-required]');
    let isValid = true;

    inputs.forEach(function (input) {
      if (input.value.trim() === '') {
        isValid = false;
      }
    });

    if (!isValid) {
      if (!alertShown) {
        alertShown = true;
        alert('* 표시된 항목은 필수 기재 항목입니다.');
        event.preventDefault();
      } else {
        alert('* 표시된 항목은 필수 기재 항목입니다.');
        event.preventDefault();
      }
    } else {
      alertShown = false;
    }
  });
});
